import React, { useMemo } from 'react';
import { formatDateRangeForApi } from '@modules/monitor/resource-triage/components/MetricsTrendPanel';
import { useDailyMetricsRepository } from 'new/state/metrics/repository/useDailyMetricsRepository';
import { useCurrentOrg } from 'new/hooks/adapters/useCurrentOrg';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import { ViewType } from '../../constants/viewTypes';
import { MetricsChartSection } from '../MetricsChartSection';

interface AccountDailyTrendsProps {
  viewType: ViewType;
  start: Date;
  end: Date;
  onDatesChanged: (start: Date, end: Date) => void;
}

export const AccountDailyTrends = ({
  viewType,
  start,
  end,
  onDatesChanged,
}: AccountDailyTrendsProps) => {
  const org = useCurrentOrg();
  const user = useCurrentUser();

  const { start: from, end: to } = useMemo(
    () => formatDateRangeForApi({ start, end }),
    [start, end],
  );

  const params =
    viewType === ViewType.Org ? { org_id: org.id, from, to } : { owner_id: user.id, from, to };

  const { data, isLoading, isFetching } = useDailyMetricsRepository(params);

  const metricsData = useMemo(
    () => (data ? { metrics: Object.fromEntries(data.map((m) => [m.time, m])) } : null),
    [data],
  );

  return (
    <MetricsChartSection
      title="Daily Usage Trends"
      viewType={viewType}
      data={metricsData}
      loading={isLoading || isFetching}
      start={start}
      end={end}
      onDatesChanged={onDatesChanged}
    />
  );
};
